module.exports = __webpack_public_path__ + "img/icon_menu_disciplina_hover.38911e54.svg";